<div class="box-number" tabindex="1">
  <ng-content></ng-content>
</div>
